import React from 'react'
import { Link } from 'react-router-dom'

export interface DashboardProps {}

export const Dashboard: React.FC<DashboardProps> = () => {
  return (
    <main className='my-c-dashboard'>
      <h1 className='my-u-mb--8 my-u-mt--0' id='maincontent' tabIndex={-1}> Dashboard</h1>
      <p><Link to={{ pathname: '/medicare-complaint' }}>Medicare-complaint-form</Link></p>
      <p><Link to={{ pathname: '/account-settings' }}>Account Settings</Link></p>
      <p><Link to={{ pathname: '/account-settings/auth-rep' }}>Auth Reps</Link></p>
      <p><Link to={{ pathname: '/account-settings/auth-rep/new' }}>Create New Auth Rep</Link></p>
      <p><Link to={{ pathname: '/eMSN' }}>View eMSNs</Link></p>
    </main>
  )
}
